import { graphql } from '@guuru/graphql-common/gql';
import communityExpertFragment from '../../../graphql/fragments/CommunityExpertFragment';

export default graphql(
  `
    query GetPersistedExpertProfile($partnerId: ID!, $expertId: ID!) {
      community(id: $partnerId) {
        id
        expert(expertId: $expertId) {
          ...CommunityExpertFragment
          bestFeedbackComments {
            comment
          }
          conversationLevel
          mentions {
            id
            summary
            url
            headline
          }
          totalMentions
        }
      }
    }
  `,
  [communityExpertFragment],
);
